import EmailAPIService from "src/servicehandlers/EmailAPIService";
const emailAPIService = new EmailAPIService();

export default {
  async getEmailTemplates(templateNames) {
    const templates = [];
    for (const templateName of templateNames) {
      const templateData = await emailAPIService.getByName(templateName.name);
      templates.push({
        name: templateName.name,
        title: templateName.title,
        subject: templateData?.subject || "",
        body: templateData?.body || "",
        variables: templateName.variables,
      });
    }
    return templates;
  },

  async saveEmailTemplates(updatedTemplates) {
    for (const template of updatedTemplates) {
      await emailAPIService.upsert({
        name: template.name,
        subject: template.subject,
        body: template.body,
      });
    }
  },

  replacePlaceholders(template, data) {
    let result = template;
    for (const [key, value] of Object.entries(data)) {
      const placeholder = new RegExp(`{{${key}}}`, "g");
      result = result.replace(placeholder, value || "");
    }
    return result;
  },

  generateFooterButtons(
    cancelAction,
    confirmAction,
    confirmActionLabel = "Send",
  ) {
    return [
      {
        label: "Cancel",
        onClick: cancelAction,
      },
      {
        label: confirmActionLabel,
        onClick: confirmAction,
      },
    ];
  },
};
